/* Stylesheet */

.logout {
  --min-height: 52px;
  --background: transparent;
  --border-color: #3a4b64;
  --color: #ffffff;
  border-radius: 4px;

  .icon {
    color: #ffffff;
  }
}
